import { combineReducers } from 'redux';
import layers from './layers/Reducer';
import activeLayers from './active_layers/Reducer';
import layerSettingsReducer from './layer_settings/Reducer';
import highlights from './highlights/Reducer';
import features from './features/Reducer';
import lookups from './lookups/Reducer';
import user from './user/Reducer';
import map from './map/Reducer';
import { MAIN_MAP, SITE_CARD_MAP, PRINT_MAP } from './map/Constants';
import panels from './panel/Reducer';
import project from './project/Reducer';
import search_panel from './panel/search_panel/Reducer';
import print_panel from './panel/print/Reducer';
import parcelPanel from './parcel/Reducer';
import search from './search/Reducer';
import analysis from './analysis/Reducer';
import markerReducer from './markers/Reducer';
import siteCardReducer from './site_card/Reducer';
import comparableReducer from './comparable/Reducer';
import notificationReducer from './notification/Reducer';
import bookmarkReducer from './bookmark/Reducer';
import planningReducer from './planning/Reducer';
import uiReducer from './ui/Reducer';
import landAssemblyReducer from './land_assembly/Reducer';
import ownershipReducer from './ownership/Reducer';
import purchaseDeedReducer from './purchase_deed/Reducer';
import orderReducer from './order/Reducer';

export default combineReducers({
    layers: layers,
    activeLayers: activeLayers,
    layerSettingsReducer: layerSettingsReducer,
    highlights: highlights,
    features: features,
    lookups: lookups,
    [MAIN_MAP]: map(MAIN_MAP),
    [SITE_CARD_MAP]: map(SITE_CARD_MAP),
    [PRINT_MAP]: map(PRINT_MAP),
    user: user,
    panels: panels,
    project: project,
    search_panel: search_panel, // related to search in layer list
    print_panel: print_panel,
    parcelPanel: parcelPanel,
    search: search, // background search and search panel
    analysis: analysis,
    markers: markerReducer,
    siteCard: siteCardReducer,
    comparableReducer: comparableReducer,
    notificationReducer: notificationReducer,
    bookmarkReducer: bookmarkReducer,
    planningReducer: planningReducer,
    uiReducer: uiReducer,
    landAssembly: landAssemblyReducer,
    ownershipReducer: ownershipReducer,
    purchaseDeedReducer: purchaseDeedReducer,
    orderReducer: orderReducer
});
